import React, { useState } from "react";
import { Box, FormControlLabel, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";
import CustomSwitch from "../CustomSwitch";

const CustomSwitchComponent = () => {
  const [checked, setChecked] = useState(true);

  const handleCheck = () => {
    setChecked((checked) => !checked);
  };

  return (
    <>
      <Box p={3}>
        <Typography variant={"h6"} color={"text.primary"}>
          Custom Text Switch
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          switch thumb inside switch track. with manually added text.
        </Typography>
      </Box>
      <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
        <PreviewAndEditor
          title={
            "Custom Switch where you can add active/inactive text whatever needed. You can pass - color, size, checked, onChange, disabled, activeText, inactiveText."
          }
          language={"js"}
          value={
            "" +
            "             <FormControlLabel\n" +
            "              sx={{ gap: 1 }}\n" +
            "              control={\n" +
            "                <CustomSwitch\n" +
            '                  color={"primary.main"}\n' +
            "                  checked={checked}\n" +
            '                  activeText={"Active"}\n' +
            '                  inactiveText={"Pause"}\n' +
            "                  onChange={handleCheck}\n" +
            "                  disabled={false}\n" +
            "                />\n" +
            "              }\n" +
            '              label="Default Custom Switch"\n' +
            "            />\n\n\n\n" +
            "            <FormControlLabel\n" +
            "              sx={{ gap: 1 }}\n" +
            "              control={\n" +
            "                <CustomSwitch\n" +
            '                  size={"small"}\n' +
            '                  color={"primary.main"}\n' +
            "                  checked={checked}\n" +
            "                  onChange={handleCheck}\n" +
            "                  disabled={false}\n" +
            "                />\n" +
            "              }\n" +
            '              label="Small Custom Switch"\n' +
            "            />"
          }
        >
          <Stack spacing={2}>
            <FormControlLabel
              sx={{ gap: 1 }}
              control={
                <CustomSwitch
                  color={"primary.main"}
                  checked={checked}
                  activeText={"Active"}
                  inactiveText={"Pause"}
                  onChange={handleCheck}
                  disabled={false}
                />
              }
              label="Default Custom Switch"
            />
            <FormControlLabel
              sx={{ gap: 1 }}
              control={
                <CustomSwitch
                  size={"small"}
                  color={"primary.main"}
                  checked={checked}
                  onChange={handleCheck}
                  disabled={false}
                />
              }
              label="Small Custom Switch"
            />
          </Stack>
        </PreviewAndEditor>
      </Box>
    </>
  );
};

export default CustomSwitchComponent;
